import axios from 'axios'
import store from '../../store/index'

const state = {
  appUser: {},
}

const mutations = {
  appUser_data (state, user) {
    state.appUser = user
  },
}

const actions = {
  appUserUpdate ({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appUsers?userId=' + user.userId,
        data: user.message,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('appUser_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appUserPasswordUpdate ({ commit }, resetPass) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appUsers/resetPass?userId=' + resetPass.userId,
        data: resetPass.message,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appUserList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appUsers/list',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appUserCreate ({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appUsers/create',
        data: user,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appUserDelete ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appUsers?userId=' + userId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appUserGet ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '​/appUsers?userId=' + userId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  userTimeline ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/user/timeline?userId=' + userId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  appUserLocationRequest ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/appUsers/location?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
